import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as propertyActions from "../../../../actionCreators/Property";
import * as dropDownActions from "../../../../actionCreators/DropDown";

import {
  Breadcrumb,
  Card,
  Form,
  Input,
  Row,
  Col,
  Select,
  Button,
  Spin,
  Empty,
} from "antd";
import DataTable from "../../../../Components/DataTable";
import moment from "moment";
import { useHistory } from "react-router-dom";

import "./style/searchProperties.css";
import { addEllipsis } from "../../../../utils";

const { Option } = Select;

const SearchProperties = ({
  searchProperties,
  searchedProperties,
  propertyTypes,
  propertyClassifications,
  getPropertyClassifications,
  // loading,
  getPropertyTypes,
  resetSearchedProperties,
  getDistricts,
  districts,
  mouzas,
  getMouzas,
  circles,
  getCircles,
  highways,
  getHighways,
  getCurrentProperty,
}) => {
  const history = useHistory();
  const [viewAdvancedFilters, setViewAdvancedFilters] = React.useState(false);
  const [filterValues, setFilterValues] = React.useState(null);
  const [form] = Form.useForm();
  const [yearFilter, setYearFilter] = React.useState([]);
  const [openViewProperty, setOpenViewProperty] = React.useState(false);
  const [propertyRowData, setPropertyRowData] = React.useState([]);
  const [circle, setCircle] = React.useState(null);
  const [district, setDistrict] = React.useState(null);
  const [isWaiting, setIsWaiting] = React.useState(false);
  const [mouza, setMouza] = React.useState(null);
  const [highway, setHighway] = React.useState(null);
  const [showText, setShowText] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [pageSize, setPageSize] = React.useState(10);
  const [loading, setLoading] = React.useState(false);
  const [length, setLength] = React.useState();
  const columns = [
    {
      title: "Owner Name",
      dataIndex: "property_owners",
      key: "property_owners",
      render: (property_owners, record) => {
        return (
          <span>
            {" "}
            {addEllipsis(property_owners.map((e) => e.name).join(","))}
          </span>
        );
      },
    },
    {
      title: "Circle",
      dataIndex: "circle",
      key: "circle",
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Highway",
      dataIndex: "highway",
      render: (highway) => (highway ? highway?.name : "---"),
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (address, record) =>
        record?.plot_number +
        ", " +
        record?.street_address +
        ", " +
        record?.road_name,
    },
    {
      title: "Tax Inspector",
      dataIndex: "property_inspector",
      render: (property_inspector) =>
        property_inspector ? property_inspector?.user?.full_name : "---",
    },
    {
      title: "PIN",
      dataIndex: "pin",
      key: "pin",
      render: (pin) => (pin ? pin : "---"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, row) => {
        if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === null
        ) {
          return <span>Awaiting Approval</span>;
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "APPROVED"
        ) {
          for (let data of row?.property_owners) {
            if (data?.objections?.length > 0) {
              if (data?.objections[0]?.status === "submitted") {
                return <span>Objection Submitted</span>;
              } else if (data?.objections[0]?.status === "sent") {
                return <span>Objection Sent to TI</span>;
              } else {
                return <span>PH9 issued</span>;
              }
            } else {
              return <span>PH9 issued</span>;
            }
          }
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "REJECTED"
        ) {
          return <span>CRF Request Declined</span>;
        } else if (row.approval_status === "rejected") {
          return <span style={{ color: "red" }}>Rejected</span>;
        } else if (
          row.approval_status === null &&
          row.submission_type === "submitted"
        ) {
          return "Awaiting Approval";
        } else if (row.approval_status === "approved" && row.pin === null) {
          return "Awaiting PIN";
        } else if (status !== null) {
          return status.charAt(0).toUpperCase() + status.slice(1);
        }

        // else if (status !== null) {
        //   return status.charAt(0).toUpperCase() + status.slice(1);
        // }
      },
    },
    {
      title: "Actions",
      width: "10%",
      dataIndex: "status",
      render: (status, row) => {
        if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === null
        ) {
          return (
            <span style={{ color: "#2196F3", textDecoration: "underline" }}>
              Open CRF
            </span>
          );
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "APPROVED"
        ) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForPh9Form(row);
              }}
            >
              Open PH9
            </span>
          );
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "REJECTED"
        ) {
          return (
            <span style={{ color: "#2196F3", textDecoration: "underline" }}>
              Open CRF
            </span>
          );
        } else if (row.approval_status === "rejected") {
          return <span style={{ color: "red" }}>---</span>;
        } else if (
          row.approval_status === null &&
          row.submission_type === "submitted"
        ) {
          return "Awaiting Approval";
        } else if (row.approval_status === "approved" && row.pin === null) {
          return "---";
        } else if (status !== null) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForPhOneForm(row);
              }}
            >
              Open PH1
            </span>
          );
        }
      },
    },
  ];
  const handleFinish = (values) => {
    setLength(null);
    // setLoading(true)
    values = {
      ...values,
      years: values.year?.toString(),
    };

    if (circle) {
      values = { ...values, circle_id: circle };
    }
    if (district) {
      values = { ...values, district_id: district };
    }
    if (mouza) {
      values = { ...values, mouza_id: mouza };
    }
    if (highway) {
      values = { ...values, highway_id: highway };
    }

    searchProperties({ page: 0, pageSize: pageSize, ...values });
    setFilterValues(values);
    setLength(null);
    setShowText(false);
    setIsWaiting(true);
  };

  const handleTablePageChange = (tableChangeData) => {
    const { current, pageSize } = tableChangeData;
    setPageSize(pageSize);
    setLoading(true);
    setLength(searchedProperties.data.length);
    searchProperties({
      page: current - 1,
      pageSize: pageSize,
      ...filterValues,
    });
  };

  const onTableRowClickForPhOneForm = (data) => {
    getCurrentProperty(data);
    history.push("/properties/ph1/" + data.id);
  };
  const onTableRowClickForPh9Form = (data) => {
    getCurrentProperty(data);
    history.push("/properties/ph9/" + data.id);
  };
  const handlePropertyRowData = (data) => {
    setPropertyRowData(data);
    history.push("/search-property/" + data.id);
  };

  React.useEffect(() => {
    const circleHighway = circles.data?.map((circleh) => circleh?.id);
    getPropertyTypes();
    getPropertyClassifications();
    if (!circle) {
      getHighways();
    } else if (circle) {
      getHighways({ circle_id: circle });
    }

    const yearDiff = 5;
    const currentYear = parseInt(moment().format("YYYY"));
    const difference = currentYear - yearDiff;
    let options = [];
    for (let i = 0; i <= yearDiff; i++) {
      let firstRangeYear = difference + i;
      let secondRangeYear = firstRangeYear + 1;
      options.push({
        val: firstRangeYear,
        opt: `${firstRangeYear} - ${secondRangeYear}`,
      });
    }
    setYearFilter(options.reverse());
  }, [
    circle,
    circles.data,
    getHighways,
    getPropertyClassifications,
    getPropertyTypes,
  ]);

  React.useEffect(() => {
    getDistricts();
    getMouzas();
    getCircles();
  }, []);

  React.useEffect(() => {
    if (!searchedProperties.loading) {
      if (searchedProperties.data?.length > 0) {
        setLength(searchedProperties.data?.length);
        setLoading(false);
        setPagination(searchedProperties.pagination);
        searchedProperties.data.forEach((element) => {
          element.key = element.id;
        });
        setShowText(false);
        setIsWaiting(false);
      } else {
        if (isWaiting) {
          setShowText(true);
          setIsWaiting(false);
        }
      }
    }
  }, [length, searchedProperties.loading, searchedProperties, isWaiting]);

  return (
    <div className="search-properties-wrapper">
      <Breadcrumb className="heading">
        <Breadcrumb.Item className="heading-faded">Properties</Breadcrumb.Item>
        <Breadcrumb.Item>Search Properties</Breadcrumb.Item>
      </Breadcrumb>
      <>
        <Card title={<span className="card-heading">Search Filters</span>}>
          <Form onFinish={handleFinish} form={form}>
            <Row gutter={["16", "0"]}>
              <Col span={6}>
                <Form.Item name="pin">
                  <Input size="large" placeholder="PIN" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="owner_cnic">
                  <Input size="large" placeholder="Owner CNIC" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Select
                    placeholder="District"
                    value={district}
                    disabled={districts.data ? false : true}
                    size="large"
                    className="select-field"
                    allowClear
                    onChange={(event) => setDistrict(event)}
                  >
                    {districts.data &&
                      districts.data.map((district) => {
                        return (
                          <Option value={district.id}>{district.name}</Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Select
                    placeholder="Mouza"
                    value={mouza}
                    disabled={mouzas.data ? false : true}
                    size="large"
                    className="select-field"
                    allowClear
                    onChange={(event) => setMouza(event)}
                  >
                    {mouzas.data &&
                      mouzas.data.map((mouza) => {
                        return <Option value={mouza.id}>{mouza.name}</Option>;
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={["16", "0"]}>
              <Col span={6}>
                <Form.Item>
                  <Select
                    placeholder="Circle"
                    value={circle}
                    disabled={circles?.data ? false : true}
                    size="large"
                    className="select-field"
                    allowClear
                    onChange={(event) => setCircle(event)}
                  >
                    {circles?.data &&
                      circles?.data?.map((circle) => {
                        return (
                          <Option value={circle?.id}>{circle?.name}</Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>
              {viewAdvancedFilters ? (
                <>
                  <Col span={6}>
                    <Form.Item name="highway_id">
                      <Select
                        placeholder="Highway Name"
                        size="large"
                        className="select-field"
                        allowClear
                        onChange={(event) => setHighway(event)}
                      >
                        {highways?.data?.map((type) => (
                          <Option key={type.id} value={type.id}>
                            {type.code ? (
                              <>{type.name + " - " + type?.code}</>
                            ) : (
                              <>{type?.name}</>
                            )}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="property_type_id">
                      <Select
                        placeholder="Property Type"
                        size="large"
                        className="select-field"
                        allowClear
                      >
                        {propertyTypes?.map((type) => (
                          <Option key={type.id} value={type.id}>
                            {type.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="property_classification">
                      <Select
                        placeholder="Property Classification"
                        size="large"
                        className="select-field"
                        allowClear
                      >
                        {propertyClassifications?.map((type) => (
                          <Option key={type.id} value={type.id}>
                            {type.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="year">
                      <Select
                        placeholder="Year"
                        size="large"
                        className="select-field"
                        allowClear
                      >
                        {yearFilter.map((filter) => (
                          <Option key={filter.val} value={filter.val}>
                            {filter.opt}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="property_number">
                      <Input size="large" placeholder="Property No." />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="owner_name">
                      <Input size="large" placeholder="Owner Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="locality">
                      <Input size="large" placeholder="Cluster Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="status">
                      <Select
                        placeholder="Payment Status"
                        size="large"
                        className="select-field"
                        allowClear
                      >
                        <Option key={1} value={"PAID"}>
                          PAID
                        </Option>
                        <Option key={2} value={"UNPAID"}>
                          UNPAID
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="align-button">
                    <Button
                      type="link"
                      className="advance-filter-button"
                      onClick={() => setViewAdvancedFilters(false)}
                    >
                      View Basic Filters
                    </Button>
                  </Col>
                </>
              ) : (
                <Col className="align-button">
                  <Button
                    type="link"
                    className="advance-filter-button"
                    onClick={() => setViewAdvancedFilters(true)}
                  >
                    View Advanced Filters
                  </Button>
                </Col>
              )}
            </Row>
            <Col span={24}>
              <Row gutter={["16", "16"]}>
                <Col>
                  <Button
                    type="primary"
                    // loading={loading}
                    htmlType="submit"
                  >
                    Apply Filter
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="clear-all-button"
                    type="default"
                    onClick={() => {
                      form.resetFields();
                      resetSearchedProperties();
                      setCircle(null);
                      setDistrict(null);
                      setHighway(null);
                      setMouza(null);
                      setLength(null);
                      setShowText(false);
                      setIsWaiting(false);
                    }}
                  >
                    Clear All
                  </Button>
                </Col>
              </Row>
            </Col>
          </Form>
        </Card>
      </>

      <Row style={{ marginTop: "10px" }}>
        <Col span={24}>
          {length && !isWaiting ? (
            <DataTable
              columns={columns}
              pagination={pagination}
              loading={loading}
              data={searchedProperties.data}
              handleTableValuesChange={handleTablePageChange}
              scroll={{ x: "100vw" }}
              onRowClick={(data) => handlePropertyRowData(data)}
            />
          ) : (
            showText === true && (
              <div className="empty-result-container">
                <Empty description={<>No Results Found For Your Filter</>} />
              </div>
            )
          )}
          {isWaiting && (
            <div className="spinner-wrapper">
              <Spin size="large" className="spinner-component" />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = ({
  property: { searchedProperties, loading },
  dropDown: {
    propertyTypes,
    propertyClassifications,
    buildingTypes,
    highways,
    districts,
    circles,
    mouzas,
  },
}) => ({
  searchedProperties,
  loading,
  propertyTypes,
  propertyClassifications,
  buildingTypes,
  districts,
  highways,
  circles,
  mouzas,
});

const mapDispatchToProps = (dispatch) => ({
  searchProperties: bindActionCreators(
    propertyActions.searchProperties,
    dispatch
  ),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
  getPropertyTypes: bindActionCreators(
    dropDownActions.getPropertyTypes,
    dispatch
  ),
  getPropertyClassifications: bindActionCreators(
    dropDownActions.getPropertyClassifications,
    dispatch
  ),
  resetSearchedProperties: bindActionCreators(
    propertyActions.resetSearchedProperties,
    dispatch
  ),
  getDistricts: bindActionCreators(dropDownActions.getDistricts, dispatch),
  getCircles: bindActionCreators(dropDownActions.getCircles, dispatch),
  getMouzas: bindActionCreators(dropDownActions.getMouzas, dispatch),
  getHighways: bindActionCreators(dropDownActions.getHighways, dispatch),
});

SearchProperties.propTypes = {
  searchProperties: PropTypes.func.isRequired,
  getPropertyTypes: PropTypes.func.isRequired,
  getPropertyClassifications: PropTypes.func.isRequired,
  getHighways: PropTypes.func.isRequired,
  resetSearchedProperties: PropTypes.func.isRequired,
  getDistricts: PropTypes.func.isRequired,
  getCircles: PropTypes.func.isRequired,
  getMouzas: PropTypes.func.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchProperties);
